<template>
    <b-card class="mb-3">
        <div class="mx-0 mb-4 row">
            <h5 class="">
                {{ $t('menu.createKkm') }}
            </h5>
            <div class="ml-auto">
                <button type="button" class="close" @click="closeForm" :title="$t('general.cancel')">
                    <close-icon title="" />
                </button>
            </div>
        </div>
        <b-alert variant="danger" :show="showAlert">
            {{ alert }}
        </b-alert>
        <b-modal ref="kkmCreatedModal" :title="$t('kkm.createdMessage', [createdKkmSfdNum])" hide-footer lazy>
            <div class="row justify-content-center">
                <b-btn variant="outline-success" @click="clearForm">
                    <plus-icon title="" />&nbsp;{{ $t('general.createNew') }}
                </b-btn>
            </div>
            <div class="row justify-content-center mt-3">
                <b-btn variant="primary" @click="goToKkmList">{{ $t('kkm.toKkmList') }}</b-btn>
            </div>
        </b-modal>
        <b-form @submit.prevent="createKkm">
            <b-form-group :label="$t('kkm.qiwiTerminal')" label-cols-sm="3">
                <b-form-radio-group v-model="formData.isQiwiTerminal" @change="isQiwiTerminalChanged()">
                    <b-form-radio :value="true">{{ $t('kkm.yes') }}</b-form-radio>
                    <b-form-radio :value="false">{{ $t('kkm.no') }}</b-form-radio>
                </b-form-radio-group>
            </b-form-group>
            <b-form-group v-if="formData.isQiwiTerminal" :label="$t('kkm.qiwiTerminalNumber')" label-cols-sm="3">
                <b-form-input v-model="formData.qiwiTerminalNumber" required @change="qiwiTerminalNumberChanged()"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('kkm.kkmSfdNum')" label-cols-sm="3">
                <b-form-input v-model="formData.sfdNumber" :disabled="formData.isQiwiTerminal"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('kkm.inspectionName')" label-cols-sm="3">
                <multiselect v-model="selectedTaxOrg" :options="inspections" @input="taxOrgSelected"
                            :close-on-select="true" :hide-selected="true" :showNoResults="false"
                            :custom-label="taxOrgLabel" :placeholder="$t('general.select')" :select-label="''">
                    <template slot="noOptions">
                        <span>
                            {{ $t('general.enterValue' )}}
                        </span>
                    </template>
                </multiselect>
            </b-form-group>
            <b-form-group :label="$t('kkm.openDate')" label-cols-sm="3">
                <date-picker v-model="formData.openingDate" type="datetime" format="DD.MM.YYYY HH:mm:ss"
                    input-class="form-control" :clearable="false" confirm :first-day-of-week="1"
                    :lang="datePickerLocale" required></date-picker>
            </b-form-group>
            <b-form-group :label="$t('kkm.timezone')" label-cols-sm="3">
                <b-form-input v-model="formData.timezone" required type="number"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('kkm.cashierCode')" label-cols-sm="3">
                <the-mask 
                    v-model="formData.defaultCashierCode"
                    :disabled="formData.isQiwiTerminal" 
                    mask="#########" 
                    :masked="true" 
                    class="form-control" 
                    required />
            </b-form-group>
            <b-form-group :label="$t('kkm.cashierName')" label-cols-sm="3">
                <b-form-input v-model="formData.defaultCashierName" required :disabled="formData.isQiwiTerminal"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('kkm.ofdConnected')" label-cols-sm="3">
                <b-form-checkbox v-model="formData.isOfdConnected" disabled></b-form-checkbox>
            </b-form-group>
            <b-form-group :label="$t('kkm.pointTitle')" label-cols-sm="3">
                <b-form-input v-model="formData.salePointTitle" required></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('kkm.pointAddressCity')" label-cols-sm="3">
                <multiselect v-model="selectedCity" :options="cities" :close-on-select="true" :hide-selected="true" :show-no-results="false"
                            @search-change="findCity" :internal-search="false"
                            label="name" :placeholder="$t('general.enterValue')" :select-label="''">
                    <template slot="noOptions">
                        <span>
                            {{ $t('general.enterValue' )}}
                        </span>
                    </template>
                </multiselect>
            </b-form-group>
            <b-form-group v-show="selectedCity" :label="$t('kkm.pointAddressStreet')" label-cols-sm="3">
                <multiselect v-model="selectedStreet" :options="streets" @input="addressSelected"
                            :close-on-select="true" :hide-selected="true" :show-no-results="false"
                            @search-change="findAddress" :internal-search="false"
                            label="name" :placeholder="$t('general.enterValue')" :select-label="''">
                    <template slot="noOptions">
                        <span>
                            {{ $t('general.enterValue' )}}
                        </span>
                    </template>
                </multiselect>
            </b-form-group>
            <b-form-group v-show="selectedStreet" :label="$t('kkm.pointAddressHouse')" label-cols-sm="3">
                <vue-bootstrap-typeahead v-model="formData.salePointAddressHome" :data="houses" :serializer="h => h.name"
                    :min-matching-chars="1" />
            </b-form-group>
            <b-form-row class="justify-content-end mx-0">
                <b-button type="button" variant="danger" @click="closeForm" :disabled="isDisabled" class="mr-2">
                    <close-icon title="" />&nbsp;{{ $t('general.cancel') }}
                </b-button>
                <b-button type="submit" variant="success" :disabled="isDisabled">
                    <save-icon title="" />&nbsp;{{ $t('general.save') }}
                </b-button>
            </b-form-row>
        </b-form>
    </b-card>
</template>

<script>
/* eslint-disable */
import { executeAfterTwoSeconds } from '@/utils/utils';

export default {
    name: 'createKkmForm',
    props: {
        toKkmList: Function,
        closeForm: Function,
        inspections: Array
    },
    data () {
        return {
            showAlert: false,
            showSuccessAlert: false,
            alert: '',
            formData: {
                isQiwiTerminal: true,
                qiwiTerminalNumber: null,
                dealerId: this.$route.params.dealerId,
                sfdNumber: '',
                taxOrganizationId: null,
                factoryNumber: '',
                defaultCashierCode: 1,
                defaultCashierName: '',
                openingDate: new Date(),
                timezone: new Date().getTimezoneOffset() / -60,
                isOfdConnected: true,
                salePointTitle: '',
                salePointAddressId: null,
                salePointAddressHome: null
            },
            selectedTaxOrg: null,
            selectedCity: null,
            selectedStreet: null,
            cities: [],
            streets: [],
            houses: [],
            createdKkmSfdNum: '',
            datePickerLocale: this.$store.getters.locale.toLowerCase()
        }
    },
    computed: {
        isDisabled: function () {
            return this.$store.getters.isLoading
        }
    },
    methods: {
        findCity: executeAfterTwoSeconds(function(query) {
            if (query.length < 3)
                return;

            const request = {
                data: { address: query },
                onSuccess: cities => this.cities = cities,
                onError: this.displayAlert 
            };

            this.$request.getCities(this, request);
        }),
        findAddress: executeAfterTwoSeconds(function (query) {
            if (query.length < 3)
                return;

            const request = {
                data: { 
                    address: query,
                    parentId: this.selectedCity.pointId 
                },
                onSuccess: streets => this.streets = streets,
                onError: this.displayAlert 
            };

            this.$request.getStreets(this, request);
        }),
        addressSelected: executeAfterTwoSeconds(function (house) {
            this.formData.salePointAddressId = house != null 
                ? house.id 
                : null;
            
            const request = {
                data: { parentId: this.formData.salePointAddressId },
                onSuccess: houses => this.houses = houses,
                onError: this.displayAlert 
            };

            this.$request.getHouses(this, request);
        }),
        clearForm: function () {
            this.formData.dealerId = this.$route.params.id
            this.formData.sfdNumber = ''
            this.formData.taxOrganizationId = null
            this.formData.factoryNumber = ''
            this.formData.cashierId = null
            this.formData.openingDate = new Date()
            this.formData.timezone = new Date().getTimezoneOffset() / -60
            this.formData.isOfdConnected = false
            this.formData.salePointTitle = ''
            this.formData.salePointAddress = ''
            this.$refs.kkmCreatedModal.hide()
        },
        goToKkmList: function () {
            this.$refs.kkmCreatedModal.hide()
            this.closeForm()
            this.toKkmList({ dealerId: this.$route.params.id || this.$route.params.dealerId })
        },
        createKkm: function () {
            this.hideAlert()
            if (this.formData.salePointAddressId === null || this.formData.salePointAddressHome === null || this.formData.salePointAddressHome.trim() === '') {
                this.displayAlert('addressMustBeSet')
                return
            }
            if (this.formData.taxOrganizationId == null) {
                this.displayAlert('taxorgIdMustBeSet')
                return
            }
            this.$request.sendRequest(this, this.$appConfig.apiUrls.kkm.create,
                this.formData, result => {
                    this.createdKkmSfdNum = result.value
                    this.$refs.kkmCreatedModal.show()
                }, this.displayAlert)
        },
        hideAlert: function () {
            this.showAlert = false
            this.alert = ''
        },
        displayAlert: function (errorCode) {
            this.alert = this.$i18n.t(`errors.${errorCode}`)
            this.showAlert = true
        },
        taxOrgSelected(value) {
            this.formData.taxOrganizationId = value ? value.id : null
        },
        taxOrgLabel: function ({ code, name }) {
            return `${code} - ${name}`
        },
        isQiwiTerminalChanged: function () {
            this.formData.qiwiTerminalNumber = null
            this.formData.sfdNumber = null
            this.formData.defaultCashierCode = 1
            this.formData.defaultCashierName = null
        },
        qiwiTerminalNumberChanged() {
            let sfdNumber = this.formData.qiwiTerminalNumber;

            if (sfdNumber != null)
                sfdNumber = sfdNumber.replace(/\s/g, '');

            this.formData.sfdNumber = sfdNumber;
            this.formData.defaultCashierName = 'Терминал'
        }
    }
}
</script>
